export const ROOT_HEADER_SLOT = 'header';
export const ROOT_MAIN_SLOT = 'main';
export const ROOT_SIDE_SLOT = 'side';
export const ROOT_BOTTOM_SLOT = 'bottom';

export interface HeaderSlotProps {
  isSticky: boolean;
}

export interface SidebarSlotProps {
  isSticky: boolean;
  isFullHeight: boolean;
}

export interface BottombarSlotProps {
  isSticky: boolean;
}
